<template>
  <div class="container">
    <div class="box-container">
      <div class="field">
        <label>Email</label>
        <input v-model="email" type="text" class="readonly" readonly />
      </div>

      <div class="field">
        <label>First Name</label>
        <input v-model="firstName" type="text" />
      </div>

      <div class="field">
        <label>Last Name</label>
        <input v-model="lastName" type="text" />
      </div>

      <div class="field">
        <label>Phone</label>
        <input v-model="phone" type="number" class="phone" />
      </div>

      <div class="field">
        <label>Title</label>
        <input :value="title ? title.name : ''" type="text" readonly class="readonly" />
      </div>

      <div class="field">
        <label>Division</label>
        <input :value="division ? division.name : ''" type="text" readonly class="readonly" />
      </div>

      <div class="field">
        <label>College</label>
        <input :value="college ? college.name : ''" type="text" readonly class="readonly" />
      </div>

      <div class="btn-container">
        <button
          :disabled="isDisabled"
          :class="{'disabled': isDisabled}"
          class="loadmore"
          @click="save"
        >Save</button>
        <button class="logout-link" v-if="$store.state.coach" @click="logout">Logout</button>
      </div>

      <div class="alert alert-success" v-if="showAlert">You have updated your profile!</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { db } from "../db";
import firebase from "firebase/app";
export default {
  data() {
    return {
      email: this.$store.state.coach.email,
      firstName: this.$store.state.coach.firstName,
      lastName: this.$store.state.coach.lastName,
      phone: this.$store.state.coach.phone,
      title: null,
      division: null,
      college: null,
      showAlert: false
    };
  },
  computed: {
    isDisabled() {
      if (
        this.firstName === this.$store.state.coach.firstName &&
        this.lastName === this.$store.state.coach.lastName &&
        this.phone === this.$store.state.coach.phone
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {
    const titleRef = this.$store.state.coach.title.path;
    db.doc(titleRef)
      .get()
      .then(title => {
        this.title = title.data();
      });

    const divisionRef = this.$store.state.coach.division.path;
    db.doc(divisionRef)
      .get()
      .then(division => {
        this.division = division.data();
      });

    const collegeRef = this.$store.state.coach.college.path;
    db.doc(collegeRef)
      .get()
      .then(college => {
        this.college = college.data();
      });
  },
  methods: {
    save() {
      this.$store
        .dispatch("updateCoach", {
          firstName: this.firstName,
          lastName: this.lastName,
          phone: this.phone
        })
        .then(() => {
          this.showAlert = true;
          setTimeout(() => {
            this.showAlert = false;
          }, 3000);
        });
    },
    logout(){
      this.$store.dispatch('logout').then(()=>{
        this.$router.push('/');
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
    height: 115vh;
}
.box-container {
  width: 100%;
  padding: 15px;
  display: flex;
  flex-wrap: wrap;
}

label {
    padding-left: 0px;
    color: #a2a2a2;
    font-weight: 400;
}

.field {
    display: block;
    width: 25%;
    margin: 2%;
}

input {
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
    width: 100%;
    border: none;
    border-bottom: 1px solid #707070;
    padding: 10px 0px;
    font-size: 18px;
    outline: none;
    color: #707070;
}

label {
  width: 100px;
}

.phone {
  -moz-appearance: textfield;
}
.phone::-webkit-inner-spin-button {
  display: none;
}
.phone::-webkit-outer-spin-button,
.phone::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.btn-container {
  align-items: baseline;
}

.logout-link {
    background: transparent;
    border: none;
    height: 20px;
    color: #cf202a;
    margin-left: 20px;
    cursor: pointer;
}
</style>